/* lua.js generated code 0.3.0 */

var LoadingBar = xClass("LoadingBar", cc.Node)
var ProgressWidth = 450
var ProgressHeight = 60
LoadingBar.create = function () {
    var self = this
    // body
    var s = LoadingBar.new()
    s.init()
    return s
}
LoadingBar.prototype.init = function () {
    var self = this
    self._percent = 0;
    // body

    var barNode = ccui.Scale9Sprite.create()
    var size = cc.size(461.7, 68)
    self.addChild(barNode)

    let bar = ccui.Scale9Sprite.create()
    self.addChild(bar)
    self.progress = bar

    let light = ccui.Scale9Sprite.create()
    self.addChild(light)

    self.createText()
    //self.createOctopus()
    self.createWave()
    

    cc.loader.autoLoad("cocos/loading_panel.plist" , function () {
        FrameLoader.loadImageWithPlist("cocos/loading_panel.plist")
        barNode.initWithSpriteFrameName("loading_panel/barbg.png")
        barNode.setPreferredSize(size)
        barNode.setPosition(0, 0)

        bar.initWithSpriteFrameName("loading_panel/bar.png")
        bar.setInsetLeft(18)
        bar.setInsetRight(0)
        bar.setAnchorPoint(0, 1)
        bar.setPosition(-size.width/2 + 3, size.height/2 - 4)
        bar.setContentSize(cc.size(18, ProgressHeight))

        light.initWithSpriteFrameName("loading_panel/light.png")
        light.setAnchorPoint(0, 1)
        light.setPreferredSize(cc.size(440.075, 8.5))
        light.setPosition(-size.width / 2 + 8.95, size.height / 2 - 7)
    })
    self.setPercent(0)
}
LoadingBar.prototype.createWave = function () {
    var self = this
    var node = cc.Node.create()
    node.setAnchorPoint(0, 0.5)
    node.setContentSize(cc.size(20, 60))
    var newMask = cc.Sprite.create()

    var clipNode = cc.ClippingNode.create(newMask)
    node.addChild(clipNode)
    var wave = cc.Sprite.create()
    clipNode.addChild(wave)
    node.setPosition(0, -4.5)
    self.addChild(node)
    self.wave = node

    cc.loader.autoLoad("cocos/loading_panel.plist", function (err) {
        if (err) {
            return
        }
        FrameLoader.loadImageWithPlist("cocos/loading_panel.plist")
        newMask.initWithSpriteFrameName("loading_panel/wavemask.png")
        newMask.setAnchorPoint(0, 0)
        newMask.setPosition(-27, 0)
        clipNode.setAnchorPoint(0, 0)
        clipNode.setPosition(0, 0)
        clipNode.setAlphaThreshold(0.5)

        //不支持模板缓冲的情况先屏蔽遮罩 cc.stencilBits<=0
        //TODO： 需要有替代方案
        if (cc.stencilBits > 0) { 
            wave.initWithSpriteFrameName("loading_panel/wave.png")
        }
        wave.setAnchorPoint(0, 0)
        wave.setPosition(0, 0)
        wave.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.MoveTo.create(1, cc.p(0, -76)), cc.CallFunc.create(function () {
            wave.setPosition(0, 0)
        }))))
    })
}
LoadingBar.prototype.createBubbles = function () {
    var self = this
    // local bubblePositions = {
    //     {185.25, 15},{120.25, 5},{60.25, 5},{75.25, 11},{0.25, 13},
    //     {45.25, 0},{21.25, 2},{78.25, -3},{100.25, 25},{23.25, 27},
    //     {-41.25, 2},{-35.25, -4},{-200.25, 18},{-170.25, -22},{-150.25, -35},
    //     {-80.25, 25},{-43.25, 15},{-265.25, -3},{-265.25, -15},{-265.25, -9}
    // }
    // local bubbleDelayTimes = {
    //     0.2, 0.15, 0.25, 0.4, 0.6,
    //     0.2, 0.15, 0.25, 0.4, 0.6,
    //     0.2, 0.15, 0.25, 0.4, 0.6,
    //     0.2, 0.15, 0.25, 0.4, 0.6
    // }
    var clipNode = cc.ClippingRectangleNode.create()
    clipNode.setClippingRegion(CCRectMake(0, 0, 1, ProgressHeight))
    clipNode.setAnchorPoint(0, 0.5)
    clipNode.setPosition(-230, -30)
    for (var i = 1; i <= 20; i += 1) {
        var posX = math.random(50)
        var posY = 2 * i + 12
        var delayTime = math.random(400) / 100
        var bubble = cc.Sprite.createWithSpriteFrameName("loading_panel/wertyui.png")
        bubble.setScale(0.185516357421875, 0.185516357421875)
        function runBubbleAction() {
            var action = cc.Sequence.create(cc.Place.create(cc.p(0, 0)), cc.Spawn.create(cc.MoveTo.create(0.4333, cc.p(30.2, 0.65)), cc.ScaleTo.create(0.4333, 0.4134, 0.4134), cc.FadeTo.create(0.4333, 119.85)), cc.Spawn.create(cc.MoveTo.create(0.5, cc.p(110.85, 1.55)), cc.ScaleTo.create(0.5, 0.2494, 0.2494), cc.FadeTo.create(0.5, 70.5)), cc.Spawn.create(cc.FadeTo.create(0.333, 0), cc.MoveTo.create(0.333, cc.p(200, 0))), cc.Spawn.create(cc.MoveTo.create(0.4333, cc.p(280.2, 0.65)), cc.ScaleTo.create(0.4333, 0.4134, 0.4134), cc.FadeTo.create(0.4333, 119.85)), cc.Spawn.create(cc.MoveTo.create(0.5, cc.p(370.85, 1.55)), cc.ScaleTo.create(0.5, 0.2494, 0.2494), cc.FadeTo.create(0.5, 70.5)), cc.Spawn.create(cc.FadeTo.create(0.333, 0), cc.MoveTo.create(0.333, cc.p(450, 0))), cc.Spawn.create(cc.MoveTo.create(0.4333, cc.p(540.2, 0.65)), cc.ScaleTo.create(0.4333, 0.4134, 0.4134), cc.FadeTo.create(0.4333, 119.85)), cc.Spawn.create(cc.MoveTo.create(0.5, cc.p(620.85, 1.55)), cc.ScaleTo.create(0.5, 0.2494, 0.2494), cc.FadeTo.create(0.5, 70.5)), cc.Spawn.create(cc.FadeTo.create(0.333, 0), cc.MoveTo.create(0.333, cc.p(710, 0))))
            bubble.runAction(cc.RepeatForever.create(action))
        }
        var node = cc.Node.create()
        node.setPosition(posX, posY)
        node.setScale(0.512)
        node.runAction(cc.Sequence.create(cc.DelayTime.create(delayTime), cc.CallFunc.create(runBubbleAction)))
        bubble.setOpacity(0)
        node.addChild(bubble)
        clipNode.addChild(node)
    }
    self.addChild(clipNode)
    self.bubbleClip = clipNode
}
LoadingBar.prototype.createOctopus = function () {
    var self = this
    var fileName = "loading_octopus_"
    var octopus = cc.Sprite.create()
    self.addChild(octopus)
    self.octopus = octopus

    cc.loader.autoLoad("cocos/loading_octopus.plist" , function () {
        FrameLoader.loadImageWithPlist("cocos/loading_octopus.plist")
        self.octopus.initWithSpriteFrameName(fileName + "0000.png")
        octopus.setPosition(-170, -2)        
        var frames = SpriteUtil.buildFrames(fileName + "%04d.png", 0, 52)
        var animate = SpriteUtil.buildAnimate(frames, 0.0333)
        octopus.play(animate)
    })
}
LoadingBar.prototype.createText = function () {
    var self = this
    var text = ccui.TextBMFont.create()
    text.setString("0%")
    self.addChild(text)
    self.progressText = text

    cc.loader.autoLoad("font/berlinsansfb_30_bluestroke.fnt" , function () {
        text.setFntFile("font/berlinsansfb_30_bluestroke.fnt")
        text.getVirtualRenderer().setAdditionalKerning(-3)
        text.setAnchorPoint(0.5, 0)
        text.setPosition(0, -70)
    })
}
LoadingBar.prototype.setPercent = function (percent) {
    var self = this
    self._percent = percent;
    // body
    // var fakePercent = (percent * 80 + 20) / 100
    var width = Math.min(Math.max(ProgressWidth * percent, 18), ProgressWidth)
    self.progress.setContentSize(cc.size(width, ProgressHeight))
    // var borderPos = self.progress.getPositionX()
    // var pos = borderPos + width - 10
    var pos = Math.max(percent * ProgressWidth - 240, -225)
    self.wave.setPositionX(Math.min(195, pos))
    //self.octopus.setPositionX(Math.min(175, pos))
    // self.octopus.setPositionX(Math.max(-170, pos - 45))
    self.progressText.setString(tostring(Math.ceil(percent * 100)) + "%")
    // self.bubbleClip.setClippingRegion(CCRectMake(0, 0, width, ProgressHeight))
}
LoadingBar.prototype.getPercent = function () {
    return this._percent;
}
module.exports = LoadingBar
